package com.gloopgo.game.navigation

import androidx.compose.runtime.Composable

@Composable
actual fun MatchSystemBackPolicy(
    blockSystemBack: Boolean,
    content: @Composable () -> Unit,
) {
    content()
}

@Composable
actual fun ConsumeMatchSystemBack() = Unit
